
import { computed, defineComponent, nextTick, reactive, ref, toRefs, watch } from 'vue'
import jfschool from '@/api/jfschool'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { CaretRightOutlined, PauseOutlined, SoundFilled, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue'
import store from '@/store'
import flvjs from 'flv.js'
export default defineComponent({
  name: 'Player',
  props: {
    playurl: {
      type: String,
      default: () => {
        return ''
      }
    },
    playInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    definition: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    CaretRightOutlined,
    PauseOutlined,
    SoundFilled,
    FullscreenOutlined,
    FullscreenExitOutlined
  },
  setup(props: any, context: any) {
    type pageDataType = {
      url: string
      progress: string
      duration: string
      videoInfo: any
      isplay: boolean
      percent: number
      loading: boolean
      slideNum: number
      isFullScreen: boolean
      currenRate: number
      getContainer: any
      definitionList: Array<{
        definitionType: string
        definitionName: string
        definition: string
      }>
      muted: boolean
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      url: '',
      progress: formatTime(0),
      duration: '',
      videoInfo: {},
      isplay: false,
      percent: 0,
      loading: false,
      slideNum: 100,
      isFullScreen: false,
      currenRate: 1,
      getContainer: () => document.querySelector('.toolbar'),
      definitionList: [],
      muted: true
    })
    const speed = [2.0, 1.5, 1.2, 1.0, 0.75, 0.5]
    // 播放
    let timmer: any = null
    function play() {
      const video: any = document.querySelector('.jfplayer video')
      video?.play()
      setStatus(video)
    }
    function setStatus(video: any) {
      pageData.slideNum = video.volume * 100
      pageData.isplay = true
      setProgress()
      context.emit('playSatate', true)
    }
    // 暂停
    function pause() {
      const video: any = document.querySelector('.jfplayer video')
      video?.pause()
      pageData.isplay = false
      clearInterval(timmer)
      context.emit('playSatate', false)
    }
    // 音量
    function changevolume(n: number) {
      const video: any = document.querySelector('.jfplayer video')
      // volume 范围[0, 1]
      video.volume = n / 100
    }
    // 播放进度
    function changepercent(n: number) {
      if (isNaN(n)) return
      const video: any = document.querySelector('.jfplayer video')
      video.currentTime = video.duration ? (n / 100) * video.duration : 0
      pageData.progress = formatTime(video.currentTime)
    }
    // 倍速播放
    function changeRate(item: { key: number }) {
      const video: any = document.querySelector('.jfplayer video')
      video.playbackRate = item.key
      pageData.currenRate = item.key
    }
    // 清晰度
    function changeDefinition(item: { key: string }) {
      if (item.key !== pageData.videoInfo.definitionType) {
        // 记录当前播放时间
        const video: any = document.querySelector('.jfplayer video')
        const currentime = video.currentTime
        clearInterval(timmer)
        timmer = null
        context.emit('changeDefinition', { key: item.key, currentTime: currentime })
      }
    }
    function setProgress() {
      const video: any = document.querySelector('.jfplayer video')
      timmer = setInterval(() => {
        pageData.progress = formatTime(video.currentTime)
        pageData.percent = (video.currentTime / video.duration) * 100
      }, 500)
    }
    function formatTime(t: any) {
      const time = Math.round(t)
      const timetoMin = Math.floor(time / 60).toString()
      const min = timetoMin.length === 2 ? timetoMin : '0' + timetoMin
      const timetoPoint = (time % 60).toString()
      const second = timetoPoint.length === 2 ? timetoPoint : '0' + timetoPoint
      return `${min}:${second}`
    }
    // 进入全屏
    function FullScreen() {
      pageData.isFullScreen = true
    }
    // 退出全屏
    function exitFullscreen() {
      pageData.isFullScreen = false
    }
    function videoEvent() {
      const video: any = document.querySelector('.jfplayer video')
      if (!video) return
      video.addEventListener('ended', () => {
        pause()
        changepercent(0)
        video.currentTime = 0
        pageData.percent = 0
      })
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function loadvideo() {}
    watch(
      () => props.playInfo.playURL,
      (newV: any, old: any) => {
        nextTick(() => {
          const val = props.playInfo
          if (newV) {
            pageData.loading = true
            pageData.url = newV || ''
            pageData.videoInfo = val

            clearInterval(timmer)
            if (val.format === 'flv') {
              if (flvjs.isSupported()) {
                setTimeout(() => {
                  const video: any = document.querySelector('.jfplayer video')
                  const flvPlayer = flvjs.createPlayer({
                    url: newV,
                    type: 'flv'
                  })
                  flvPlayer.attachMediaElement(video)
                  flvPlayer.load()
                }, 100)
              }
            }
            pageData.definitionList = props.definition
            if (val.eventType === 'continuation') {
              // 续播
              nextTick(() => {
                timmer = null
                const video: any = document.querySelector('.jfplayer video')
                if (!video) return
                let flag = true
                video.addEventListener('canplay', function (e: any) {
                  video.volume = pageData.slideNum / 100
                  video.playbackRate = pageData.currenRate
                  if (!flag) return
                  pageData.percent = (val.currentTime / video.duration) * 100
                  pageData.isplay ? play() : pause()
                  if (!isNaN(pageData.percent)) {
                    changepercent(pageData.percent)
                  }
                  flag = false
                })
                // setTimeout(() => {
                //   pageData.isplay ? play() : pause()
                //   changepercent(pageData.percent)
                // }, 500)
              })
            } else {
              context.emit('playSatate', false)
              pageData.isplay = false
              // 视频播放地址切换，视频播放进度重置
              nextTick(() => {
                // 状态重置
                const video: any = document.querySelector('.jfplayer video')
                if (video && old) {
                  video.currentTime = 0
                  pageData.percent = 0
                  pageData.currenRate = 1
                  changepercent(0)
                }
              })
            }
            setTimeout(() => {
              pageData.loading = false
              videoEvent()
            }, 300)
          }
        })
      },
      {
        deep: true,
        immediate: true
      }
    )
    return {
      ...toRefs(pageData),
      formatTime,
      play,
      pause,
      speed,
      FullScreen,
      exitFullscreen,
      changevolume,
      changepercent,
      changeRate,
      changeDefinition,
      loadvideo
    }
  }
})
